import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as Headroom from "headroom.js";
import * as _ from "underscore";
import {on, debounce, Options} from "../utils/decorators";
import * as Cookies from 'js-cookie';


@Options({
    template: false,
    ui: {
        primaryHeader:      "[data-js-ui=site-header-primary]",
        siteNavItem:        "[data-js-ui=site-header-primary] .site-nav__item",
        primarySiteNavLi:   "[data-js-ui=site-header-primary] .site-nav__link",
        secondarySatNav:    "[data-js-ui=site-header-primary] .site-nav__sublist",
        secondaryHeader:    "[data-js-ui=site-header-secondary]",
        mobileMenu:         "[data-js-ui=site-header-mobile]",
        menuToggle:         "[data-js-ui=menu-toggle]",
        searchBar:          "[data-js-ui=search-bar--header]",
        searchBtnOpen:      "[data-js-ui=search-open-btn]",
        searchBtnClose:     "[data-js-ui=search-close-btn]",
        searchInput:        "[data-js-ui=site-header-primary] .search-bar",
        searchInputMobile:  "[data-js-ui=site-header-mobile] .search-bar",
    }

})
export default class SiteHeaderView extends Marionette.View<Backbone.Model>{

    $html = $('html');
    hideSubNav = null;

    onRender() {
        this.initHeadroom();
    }

    initHeadroom() {
        let offset = 150;
        let body = $('body');
        let headroomClasses = {
            initial: "headroom",
            pinned: "headroom--pinned",
            unpinned: "headroom--unpinned",
        };
        let ticketExpirationTime = Number(Cookies.get("_bo_ticket_expiration_time") || 0);
        // let ticketExpirationTime = new Date().getTime() + 5000; // for local testing
        let now = new Date();
        let future = new Date(ticketExpirationTime * 1000);
        let delta = future.getTime() - now.getTime();

        if(body.hasClass('compact-header')
            || body.hasClass('search-page')
            || body.hasClass('artist-page')
            || body.hasClass('piece-page')
            || body.hasClass('membership-page')
            || body.hasClass('hybrid-list-view')) {
            offset = 0;
        }

        // if($('.site-header__countdown').is(":visible")) { // for local testing
        if(delta > 0) {
            console.log('visible');
            headroomClasses = {
                initial: "headroom",
                pinned: "headroom--pinned headroom--pinned--with-countdown",
                unpinned: "headroom--unpinned headroom--unpinned--with-countdown",
            };
        }

        const el = this.el;
        const options = {
            offset: offset,
            tolerance: 0,
            classes: headroomClasses,
            onPin : function () {
                body.addClass('header-pinned');
            },
            onUnpin : function () {
                body.removeClass('header-pinned');
            },
        };

        el.headroom = new Headroom(el, options).init();

        if(delta > 0) {
            let ticketInterval = setTimeout(() => {
                el.headroom.destroy();
                this.initHeadroom();
            }, delta + 500);
        }
    }

    @on("click @ui.menuToggle")
    onMenuToggleClick(e:JQueryEventObject) {
        this.ui.mobileMenu.toggleClass('is-open');
        $('.search-results__header').toggleClass('is-visible');
        $('body').addClass('nav-open');
    }

    @on("mouseover @ui.primarySiteNavLi")
    onPrimaryMenyItemClick(e:JQueryEventObject) {
        let currentSelectedList = 'currentSelectedList';
        this.removeClass(currentSelectedList)
        e.target.parentElement.classList.add(currentSelectedList);
    }

    @on("mouseout @ui.secondarySatNav")
    onSecondaryNavMouseOut() {
        this.hideSubNav = _.delay(this.removeClass, 500, 'currentSelectedList');
    }

    @on("mouseover @ui.secondarySatNav")
    onSecondaryNavMouseOn() {
        clearTimeout(this.hideSubNav);
    }

    @on("click @ui.searchBtnOpen")
    onSearchBtnClick(e:JQueryEventObject) {
        this.openSearchBar();
    }

    @on("click @ui.searchBtnClose")
    onSearchBtnCloseClick(e: JQueryEventObject) {
        this.closeSearchBar();
    }

    @on("focus @ui.searchInputMobile")
    onMobileSearchFocus(e: JQueryEventObject) {
        console.log('search focussed');
        this.ui.mobileMenu.addClass('mobile-search-focused');
    }

    @on("blur @ui.searchInputMobile")
    onMobileSearchBlur(e: JQueryEventObject) {
        console.log('search blurred');
        this.ui.mobileMenu.removeClass('mobile-search-focused');
    }

    openSearchBar() {
        this.$html.addClass('is-showing-search');
        this.ui.searchInput.focus();
    }

    removeClass(elClassName:string) {
        var t:HTMLCollection = document.getElementsByClassName(elClassName)
        if(t.length > 0 ) {t[0].classList.remove(elClassName)}
    }

    closeSearchBar() {
        this.$html.removeClass('is-showing-search');
        this.ui.searchInput.blur();
    }
}



// WEBPACK FOOTER //
// ./@modules/views/site-header-view.ts